import React from 'react';

import placeholder from '../../assets/images/placeholder.png';
/* import male from '../../assets/icons/male-black.svg';
import female from '../../assets/icons/female-black.svg';

import { getDogBreedName, getDogType, getDogTypeIcon } from '../../helpers/dogHelpers';
import moment from 'moment'; */
import { createImageUrl } from '../../helpers/commonHelpers';

const Card = ( { mayor } ) => {
    
    /* const years = moment().diff(moment(mayor.dateOfBirth), 'years');
    const months = moment().subtract(years, 'years').diff(moment(mayor.dateOfBirth),'months'); */
    return (
        <div className="card">
            <div className="card__overlay" />
            <img src={mayor?.main_image ? createImageUrl(mayor.main_image) : placeholder} alt="mayor-profile" className="card__image" />
            {/* <div className="expandable-icon expandable-icon--gender">
                <img src={mayor.gender ? female : male} alt="type" className="expandable-icon__icon" />
                <h4 className="expandable-icon__content">
                    {mayor.gender ? 'Female' : 'Male'}
                </h4>
            </div>
            <div className="expandable-icon expandable-icon--type">
                <img src={getDogTypeIcon(mayor.type)} alt="type" className="expandable-icon__icon" />
                <h4 className="expandable-icon__content">
                    {getDogType(mayor.type)}
                </h4>
            </div> */}
            <div className="card__content">
                <h1 className="card__content__name">
                    {mayor?.firstName + ' '+ mayor?.lastName}
                </h1>
                <p className="card__content__descriptions">
                    {mayor?.municipalityName}
                </p>
                {/* <p className="card__content__descriptions">
                    {mayor?.location?.state ? mayor.location.state : 'USA'} &bull; {years} years { months === 0 && years === 0 ? months + 1 : months} months
                </p> */}
            </div>
        </div>
    );
}

export default Card;